import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';

import './marketing-buttons.scss';

export function MarketingButtons({
  entry,
  wrapperClass = 'py-2 my-2',
  wrapperStyle = null,
  fontClass = 'size-30 fw-bold',
  buttonClass = 'text-white',
  isBordered = true,
  isArticlePage = false,
  isElectricPage = false,
}) {
  const btnTracker = e => {
    const creativeId = e.currentTarget.dataset.trackingParent;
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_TOOL_SELECT,
        subaction_name: TrackingConstant.TAB_SELECT,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id: creativeId,
      },
    });
  };

  const anchorClass = 'btn btn-lg py-0_75 px-1 mb-sm-0 border-0 overflow-hidden';
  const anchorStyle = { minWidth: '220px' };
  const buttonLinkCurrent = entry.metadata('buttonLinkCurrent').value();
  const buttonLinkPast = entry.metadata('buttonLinkPast').value();
  const buttonHeadingTitle = entry.metadata('title').value();

  if (!buttonLinkCurrent && !buttonLinkPast) {
    return null; // No buttons to display
  }

  return (
    <div
      className={classnames('marketing-buttons', wrapperClass, {
        'is-bordered': isBordered,
        'is-article-page': isArticlePage,
        'is-electric-page': isElectricPage,
      })}
      style={wrapperStyle}
    >
      {buttonHeadingTitle && (
        <header className={classnames('pb-1_5 mt-0_25 pt-1_5 pt-sm-0 px-1', fontClass)}>{buttonHeadingTitle}</header>
      )}
      <div className="d-sm-flex mx-auto justify-content-center mb-0_5 mb-sm-0 px-3" style={{ gap: '24px' }}>
        {buttonLinkCurrent && (
          <a
            href={entry.metadata('buttonLinkCurrent').value()}
            className={classnames('mb-1_5', anchorClass, buttonClass)}
            target="_blank"
            rel="noopener noreferrer"
            style={anchorStyle}
            onClick={btnTracker}
            data-tracking-parent={entry.metadata('creativeIdCurrent').value() || 'Shop New Winner'}
            data-tracking-id="marketing_btn_click"
          >
            <span className="pos-r">{entry.metadata('buttonTitleCurrent').value()}</span>
          </a>
        )}
        {buttonLinkPast && (
          <a
            href={entry.metadata('buttonLinkPast').value()}
            className={classnames('mb-0_25', anchorClass, buttonClass)}
            target="_blank"
            rel="noopener noreferrer"
            style={anchorStyle}
            onClick={btnTracker}
            data-tracking-parent={entry.metadata('creativeIdPast').value() || 'Shop Used Winner'}
            data-tracking-id="marketing_btn_click"
          >
            <span className="pos-r">{entry.metadata('buttonTitlePast').value()}</span>
          </a>
        )}
      </div>
    </div>
  );
}

MarketingButtons.propTypes = {
  entry: CmsEntities.Content.isRequired,
  wrapperClass: PropTypes.string,
  fontClass: PropTypes.string,
  buttonClass: PropTypes.string,
  isBordered: PropTypes.bool,
  wrapperStyle: PropTypes.shape({}),
  isArticlePage: PropTypes.bool,
  isElectricPage: PropTypes.bool,
};
